import { useEffect, useRef, useState } from 'react';

export default function useTimer<T>(
  value: T,
  duration = 2000,
): [T, (value: T) => void] {
  const defaultItemRef = useRef(value);
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [item, setItem] = useState(value);

  const setValue = (newValue: T) => {
    if (timeoutId.current) {
      clearTimeout(timeoutId.current);
    }

    setItem(newValue);

    timeoutId.current = setTimeout(() => {
      setItem(defaultItemRef.current);
    }, duration);
  };

  useEffect(() => {
    return () => {
      if (timeoutId.current) {
        clearTimeout(timeoutId.current);
      }
    };
  }, []);

  return [item, setValue];
}
